module.exports = __webpack_public_path__ + "static/media/knowledgehub_banner.d6822820.png";